// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutEvent_container__tzVs7","title":"AboutEvent_title__6mROS"};